export class BasicPersonaInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(personaId: string, personaName: string | null);
    constructor(personaId?: string, personaName?: string | null) {
        if (personaId !== undefined) {
            this.id = personaId;
        }
        
        if (personaName !== undefined) {
            this.name = personaName;
        }        
    }
}